import { Text } from '@/ui'
import { TypographyStyles } from '@/styles'

export const TotalPlannedIncomePopup = () => (
  <>
    <Text variant={TypographyStyles.LABEL_MD}>Total Planned Income</Text>
    <Text variant={TypographyStyles.BODY_SM} className="mt-2">
      This is the sum of all therapy and non-therapy income (if applicable) that
      you’ve added to this plan.
    </Text>
  </>
)

export const TherapyIncomePopup = () => (
  <>
    <Text variant={TypographyStyles.LABEL_MD}>Therapy Income</Text>
    <Text variant={TypographyStyles.BODY_SM} className="mt-2">
      This is the sum of all therapy income that you’ve added to this plan.
    </Text>
  </>
)

export const NonTherapyIncomePopup = () => (
  <>
    <Text variant={TypographyStyles.LABEL_MD}>Non-Therapy Income</Text>
    <Text variant={TypographyStyles.BODY_SM} className="mt-2">
      This is the sum of all non-therapy income that you’ve added to this plan.
    </Text>
  </>
)

export const PerSessionRatePopup = () => (
  <>
    <Text variant={TypographyStyles.LABEL_MD}>Blended per Session Rate</Text>
    <Text variant={TypographyStyles.BODY_SM} className="mt-2">
      This is the average session rate for all your therapy income sources added
      to this plan.
    </Text>
  </>
)

export const SessionsPerMonthPopup = () => (
  <>
    <Text variant={TypographyStyles.LABEL_MD}>Sessions per Month</Text>
    <Text variant={TypographyStyles.BODY_SM} className="mt-2">
      This is the sum of all therapy income sessions you’ve added to this plan.
    </Text>
  </>
)

export const PlannedIncomePopup = () => (
  <>
    <Text variant={TypographyStyles.LABEL_MD}>Planned Income</Text>
    <Text variant={TypographyStyles.BODY_SM} className="mt-2">
      This is your forecasted monthly earnings, which you&apos;ve entered either
      by applying a plan or by inputting it manually.
    </Text>
  </>
)

export const YearIncomePopup = ({ year }: { year: number }) => (
  <>
    <Text variant={TypographyStyles.LABEL_MD}>{year} Income</Text>
    <Text variant={TypographyStyles.BODY_SM} className="mt-2">
      This is the total income that has been categorized by Heard&apos;s
      bookkeeping team for {year}.
    </Text>
  </>
)

export const YearToDateIncomePopup = ({ year }: { year: number }) => (
  <>
    <Text variant={TypographyStyles.LABEL_MD}>{year} Year-to-date Income</Text>
    <Text variant={TypographyStyles.BODY_SM} className="mt-2">
      This is the total income that has been categorized by Heard&apos;s
      bookkeeping team so far this year. The percentage increase or decrease is
      your actual year-to-date income as compared to your planned income.
      <br />
      Note: This amount may not exactly align with your planned income, as
      reimbursement times from insurance plans vary.
    </Text>
  </>
)

export const IncomeForMonthPopup = ({ year }: { year: number }) => (
  <>
    <Text variant={TypographyStyles.LABEL_MD}>{year} Income</Text>
    <Text variant={TypographyStyles.BODY_SM} className="mt-2">
      This is the total income that has been categorized by Heard&apos;s
      bookkeeping team for each month. The percentage increase or decrease is
      your actual year-to-date income as compared to your planned income.
      <br />
      Note: This amount may not exactly align with your planned income, as
      reimbursement times from insurance plans vary.
    </Text>
  </>
)
